import { createContext, useContext } from "react"

/**
 * A React context for server-side rendering (SSR).
 * @constant {Object} SSRContext
 * @property {boolean} isMobileSSR - Indicates whether the SSR is for mobile devices.
 */
export const SSRContext = createContext({ isMobileSSR: false })

/**
 * Hook for accessing the SSR context within functional AEM components.
 * @function
 * @returns {Object} The SSR context object.
 */
export const getSSRContext = () => useContext(SSRContext)
